import { Box } from '@mui/material';

import { useUserSelector } from '@occc-app/App/AppContext';
import { User_Role } from '@occc/graphql';

import { Outlet } from 'react-router-dom';
import { AppLayoutProvider } from './AppLayoutContext';
import { HeroSectionBackground } from './HeroSectionBackground';
import { FooterInfoBanner } from './footer-info-banner/footer-info-banner.component';
import {
  useFooterBannerContext,
  useFooterInfoBanner,
} from './footer-info-banner/footer-info-banner.context';
import { FOOTER_INFO_BANNER_HEIGHT } from './constants';
import { useSidebar } from './SidebarContext';

import AppBar from '../../components/AppBar';

const READ_ONLY_INDICATOR_MESSAGE =
  'You are a read-only user. Contact your manager for edit access.';

export const AppLayout = () => {
  const { isSidebarOpen, onSidebarOpen } = useSidebar();

  const user = useUserSelector();
  const isReadOnlyAdminRole = user?.userRole === User_Role.AdminReadOnly;

  const { entry } = useFooterBannerContext();

  useFooterInfoBanner(isReadOnlyAdminRole ? READ_ONLY_INDICATOR_MESSAGE : null);

  const isFooterBannerVisible = !!entry;

  return (
    <AppLayoutProvider>
      <Box
        sx={{
          pb: isFooterBannerVisible ? `${FOOTER_INFO_BANNER_HEIGHT}px` : 'unset',
        }}
      >
        <HeroSectionBackground />
        <Box sx={{ color: 'common.white' }}>
          <AppBar onSidebarOpen={onSidebarOpen} isSidebarOpen={isSidebarOpen} />
        </Box>
        <Outlet />

        {isFooterBannerVisible && (
          <FooterInfoBanner
            key={entry.id}
            message={entry.message}
            severity={entry.severity}
            details={entry.details}
          />
        )}
      </Box>
    </AppLayoutProvider>
  );
};
